import React from 'react';
import errorImage from '../assets/imagenes/items/error.png';
import '../styles/Error.css';

const Error = () => {
  return (
    <div className="error-container">
      <div className="error-text">
        <h1>LO SENTIMOS</h1>
        <p>Algo salió mal.</p>
        <p>Inténtalo más tarde</p>
      </div>
      <div className="error-image-container">
        <img src={errorImage} alt="Error" className="error-image" />
      </div>
    </div>
  );
};

export default Error;
